// extracted by mini-css-extract-plugin
export default {"container":"webgl_container__DSm-Z"};